/**
 * Coup de pouce — Attendu 1102 « multiplier et diviser par 10, 100, 1 000 ;
 * savoir compléter 1 200 = 1,2 × … » (automatisme 4e, l. 676). UNE page PAS
 * À PAS (trois temps) pour la carte neuve « Quel nombre manque ? » (clés
 * manque_*). Les cartes de 1043 (produits_* / quotients_*) gardent les
 * fiches des gens 6e 1008 et 1009 (index.js).
 *
 * L'image que l'élève a déjà : le tableau des rangs de 1008, la virgule
 * rouge PLANTÉE, le nombre qui glisse. Temps 1 : 1,2 posé dans le tableau.
 * Temps 2 : 1 200 posé dessous, le 1 a glissé des unités aux milliers, une
 * flèche compte les 3 rangs. Temps 3 : le résultat « 1 200 = 1,2 × 1 000 »
 * et deux lignes en langue d'élève : « Le 1 a glissé de 3 rangs vers la
 * gauche : × 1 000. » puis le mémo de 1008 « 1 rang : × 10. 2 rangs :
 * × 100. 3 rangs : × 1 000. » (c'est le choix qu'il reste à faire sur la
 * carte).
 *
 * SACRIFIÉ : (1,2 ; 1 000), l'exemple du programme, sous toutes ses formes
 * dans la carte neuve (gen_1102, SACRIFIE, auto-testé par
 * gen1102.self.test.js). Largeur bornée à 340 px, tailles de 1048.
 */

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ROUGE = '#DC2626';
const GRIS = '#94A3B8';
const ENCRE = '#1E293B';

const RANGS = ['milliers', 'centaines', 'dizaines', 'unités', 'dixièmes', 'centièmes'];
const X0 = 56;
const W = 50;
const YA = 70;
const YB = 134;
const H = 42;
const cx = (k) => X0 + k * W + W / 2;
const X_VIRGULE = X0 + 4 * W;

const COLONNES = RANGS.map((r, k) => `
  <text x="${cx(k)}" y="${YA - 8}" font-size="9" font-weight="bold" text-anchor="middle" fill="${k === 3 || k === 4 ? ENCRE : GRIS}">${r}</text>
  <rect x="${X0 + k * W}" y="${YA}" width="${W}" height="${H}" rx="6" fill="#F8FAFC" stroke="#CBD5E1" stroke-width="1.2"/>
  <rect x="${X0 + k * W}" y="${YB}" width="${W}" height="${H}" rx="6" fill="#F8FAFC" stroke="#CBD5E1" stroke-width="1.2"/>`).join('');

const chiffre = (k, y, c, couleur) => `<text x="${cx(k)}" y="${y + 29}" font-size="22" font-weight="bold" text-anchor="middle" fill="${couleur}">${c}</text>`;

const SVG_RANGS = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 272" width="100%" style="max-width:340px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="1 200 égale 1,2 fois combien ? Le tableau des rangs, des milliers aux centièmes, la virgule rouge plantée entre les unités et les dixièmes. Temps 1 : 1,2 est posé, le 1 dans les unités, le 2 dans les dixièmes. Temps 2 : 1 200 est posé dessous, le 1 dans les milliers, le 2 dans les centaines, deux zéros comblent les dizaines et les unités ; une flèche compte 3 rangs vers la gauche. Temps 3 : 1 200 égale 1,2 fois 1 000. Le 1 a glissé de 3 rangs vers la gauche : fois 1 000. 1 rang : fois 10. 2 rangs : fois 100. 3 rangs : fois 1 000.">
  <text x="200" y="30" font-size="16" font-weight="bold" text-anchor="middle" fill="${ENCRE}"><tspan fill="${ORANGE}">1 200</tspan> = <tspan fill="${BLEU}">1,2</tspan> × ?</text>

  <!-- le tableau des rangs, la virgule plantée -->
  ${COLONNES}
  <line x1="${X_VIRGULE}" y1="${YA - 4}" x2="${X_VIRGULE}" y2="${YB + H + 4}" stroke="${ROUGE}" stroke-width="3"/>

  <!-- temps 1 : 1,2 -->
  <g data-etape="1">
    <text x="${X0 - 8}" y="${YA + 29}" font-size="13" font-weight="bold" text-anchor="end" fill="${BLEU}">1,2</text>
    ${chiffre(3, YA, 1, BLEU)}
    ${chiffre(4, YA, 2, BLEU)}
  </g>

  <!-- temps 2 : 1 200 dessous, les 3 rangs comptés -->
  <g data-etape="2">
    <text x="${X0 - 8}" y="${YB + 29}" font-size="13" font-weight="bold" text-anchor="end" fill="${ORANGE}">1 200</text>
    ${chiffre(0, YB, 1, ORANGE)}
    ${chiffre(1, YB, 2, ORANGE)}
    ${chiffre(2, YB, 0, GRIS)}
    ${chiffre(3, YB, 0, GRIS)}
    <line x1="${cx(3) - 6}" y1="${YA + H + 8}" x2="${cx(0) + 10}" y2="${YA + H + 8}" stroke="${ORANGE}" stroke-width="2.2"/>
    <polygon points="${cx(0)},${YA + H + 8} ${cx(0) + 12},${YA + H + 3} ${cx(0) + 12},${YA + H + 13}" fill="${ORANGE}"/>
    <text x="${(cx(0) + cx(3)) / 2}" y="${YB - 3}" font-size="11" font-weight="bold" text-anchor="middle" fill="${ORANGE}">3 rangs</text>
  </g>

  <!-- temps 3 : le résultat, le geste, le mémo -->
  <g data-etape="3">
    <text x="200" y="214" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}"><tspan fill="${ORANGE}">1 200</tspan> = <tspan fill="${BLEU}">1,2</tspan> × <tspan fill="${ORANGE}">1 000</tspan></text>
    <text x="200" y="242" font-size="12" text-anchor="middle" fill="${ENCRE}">Le 1 a glissé de <tspan font-weight="bold" fill="${ORANGE}">3 rangs</tspan> vers la gauche : <tspan font-weight="bold" fill="${ORANGE}">× 1 000</tspan>.</text>
    <text x="200" y="262" font-size="12" text-anchor="middle" fill="${ENCRE}">1 rang : × 10. 2 rangs : × 100. 3 rangs : × 1 000.</text>
  </g>
</svg>`.trim();

const AIDE = { pages: [{ titre: 'Je compte les rangs', svg: SVG_RANGS }] };

const CP_1102 = {
    manque_texte_trou_saisie: AIDE,
    manque_qcm_unique: AIDE,
    manque_tableau_vf: AIDE,
};

export default CP_1102;
